import React from 'react';
import {
  components as DefaultSelectComponents,
  ValueContainerProps,
} from 'react-select';
import { useTranslation } from 'react-i18next';
import styles from '../Select.module.scss';

export default function MultiSelectValueContainer(
  props: ValueContainerProps,
): React.ReactElement {
  const { children, ...valueContainerProps } = props;
  const { isMulti, selectProps } = valueContainerProps;
  const { menuIsOpen, isSearchable } = selectProps;
  const { t } = useTranslation();

  // When searchable, hide the "Selected (N)" summary while the menu is open so
  // the search input is visible. When not searchable, always show the summary.
  const showSelectedSummary = !isSearchable || !menuIsOpen;

  if (isMulti && Array.isArray(children) && children.length) {
    return (
      // @ts-ignore
      <DefaultSelectComponents.ValueContainer
        {...valueContainerProps}
        className={styles.valueContainer}
      >
        <span className={styles.multiValueWrap}>
          {showSelectedSummary &&
            Array.isArray(children[0]) &&
            children[0].length && (
              <>
                {/* {children[0]} */}
                {t('selected')}
                {!!children[0].length && ` (${children[0].length})`}
              </>
            )}
          <span>{children[1]}</span>
        </span>
      </DefaultSelectComponents.ValueContainer>
    );
  }

  return (
    // @ts-ignore
    <DefaultSelectComponents.ValueContainer
      {...valueContainerProps}
      className={styles.valueContainer}
    >
      {children}
    </DefaultSelectComponents.ValueContainer>
  );
}
